import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/Auth';
import { jwtDecode } from 'jwt-decode';
import '../css/Login.css';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext'
import { ReactComponent as Logo } from '../assets/logo.svg';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error('Email and password are required');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Enter a valid email address');
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    try {
      const res = await login(email, password);
      localStorage.setItem('token', res.token);
      toast.success('Logged in successfully!');
      const decoded = jwtDecode(res.token);
      setUser(decoded);
      navigate('/');
    } catch (err) {
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <Logo className="login-logo" width="auto" height="auto"/>
        <h2>Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}> Login </button>
      </div>
    </div>
  );
};

export default LoginPage;
